export default () => ({
  lastSearchQuery: '',
  addressIsVerified: true
})
